import React from 'react';
import { graphql } from 'gatsby';
import { Layout } from '../components/layout';
import SectionPlain from '../components/SectionPlain';
import RequestQuoteWizard from '../components/RequestQuoteWizard';

const RequestQuote = ({ data }) => {
  const { requestQuote } = data.content.childMarkdownRemark.frontmatter;

  return (
    <Layout>
      <SectionPlain
        subTitle="Let's dive into your needs"
        title="Request a quote"
        body="Answer the questions so we will be able to get in depth about your needs and what we could offer to you."
        textCenter
      />
      <RequestQuoteWizard icons={requestQuote.icons} />
    </Layout>
  );
};

export const PageQuery = graphql`
  query {
    content: file(name: { eq: "request-quote" }) {
      childMarkdownRemark {
        frontmatter {
          requestQuote {
            icons {
              iconBuildingBig {
                publicURL
              }
              iconBuildingSmall {
                publicURL
              }
              iconEqualizer {
                publicURL
              }
              iconHouse {
                publicURL
              }
              iconList {
                publicURL
              }
              iconPortfolio {
                publicURL
              }
              iconRocket {
                publicURL
              }
              iconShoppingCart {
                publicURL
              }
              iconWand {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;

export default RequestQuote;
